// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-LandingPage-components----about-the-author-module---container---dsB1V","header":"src-components-LandingPage-components----about-the-author-module---header---2CO-A","imageWrapper":"src-components-LandingPage-components----about-the-author-module---imageWrapper---1j3fG","image":"src-components-LandingPage-components----about-the-author-module---image---1KMv_","textBlock":"src-components-LandingPage-components----about-the-author-module---textBlock---2APNE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/components/about-the-author.module.css
// module id = 532
// module chunks = 35783957827783